/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import { React, useEffect, useState } from 'react';
import SelectOption from 'react-select';

const Select = ({
  name,
  title,
  value,
  filter,
  onBlur,
  errors,
  touched,
  variant,
  options,
  rounded,
  disabled,
  readonly,
  onChange,
  placeholder,
  isSearchable,
  ...otherProps
}) => {
  const [isValid, setIsValid] = useState(
    errors && touched ? !(errors[name] && touched[name]) : true,
  );

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: rounded ? '30px' : '5px',
      borderColor: state.isFocused ? '#ddd' : !isValid ? 'red' : '#ddd',
      '&:hover': {
        borderColor: state.isFocused ? '#ddd' : !isValid ? 'red' : '#ddd',
      },
      marginLeft: rounded ? '8px' : '0px',
      minWidth: '180px',
      height: '2.8em',
    }),
    option: (options) => ({
      ...options,
      textAlign: 'left',
    }),
  };

  useEffect(() => {
    setIsValid(errors && touched ? !(errors[name] && touched[name]) : true);
  }, [errors, touched]);

  const handleChange = (item) => {
    if (onChange) onChange(name, item?.value ?? '');
  };

  const customFilter = (option, searchText) => {
    if (option.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    return false;
  };

  return (
    <div className="form-group" style={{ marginBottom: filter ? 0 : 10 }}>
      {title ? (<label htmlFor={name} className="form-label">{title}</label>)
        : (<label className="form-label" style={{ marginBottom: '1.8em' }} />)}
      <SelectOption
        {...otherProps}
        name={name}
        isClearable="true"
        options={options}
        isDisabled={disabled}
        isReadonly={readonly}
        isSearchable={isSearchable}
        styles={customStyles}
        classNamePrefix="select"
        className={`basic-single ${variant ?? ''} `}
        value={
          options?.filter((obj) => (
            obj?.value === value
          ))[0] ?? {
            label: placeholder ?? `Pilih data ${title ?? '...'}`,
            key: '',
          }
        }
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        filterOption={customFilter}
      />
      <div
        className="invalid-feedback"
        style={{ display: isValid ? 'none' : 'block' }}
      >
        {errors ? errors[name] : ''}
      </div>
    </div>
  );
};

export default Select;
